<div class="wrapper">
  <div id="content">
    <app-pendo-badge [rightPanelOpened]="rightPanelOpened" [customPendoPosition]="{ right: '490px', zindex: 4000 }"></app-pendo-badge>
    <app-schedules-dashboard [claims]="claims" [company]="company" [columns]="columns" (rightPanelOpened)="rightPanelOpenedHandler($event)"></app-schedules-dashboard>
  </div>
</div>
